<script setup lang="ts">
import { computed, useAttrs, type HTMLAttributes } from 'vue';
import { cn } from '../ui-utils.ts';
import { useVModel } from '@vueuse/core';

const props = defineProps<{
  defaultValue?: string | number;
  modelValue?: string | number;
  class?: HTMLAttributes['class'];
}>();

const emits = defineEmits<{
  (e: 'update:modelValue', payload: string | number): void;
}>();

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
});

const attrs = useAttrs();
const inputClass = computed(() =>
  cn(
    'flex h-10 w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm font-normal ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-slate-500 focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
    props.class,
  ),
);
</script>

<template>
  <input v-if="attrs.type === 'file'" :class="inputClass" />
  <input v-else v-model="modelValue" :class="inputClass" />
</template>
